<template>
  <component :is="control">
    <template
      #hint
      v-if="hint"
    >
      <div
        v-html="hint"
        @click.stop
      ></div>
    </template>
    <template
      #append
      v-if="help"
    >
      <q-icon
        class="cursor-pointer"
        name="info"
      >
        <q-tooltip max-width="500px">
          <div v-html="help.content"></div>
        </q-tooltip>
      </q-icon>
    </template>
  </component>
</template>

<script>
export default {
  props: ["control", "help", "hint"],
};
</script>
